import React from "react";
import { useRecoilValue } from 'recoil';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Grid from '@mui/material/Grid2';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { isDebug } from "../../utils";
import { userInfo } from "../../auth/AuthProvider";
import { useBoardType } from "../../hooks/useBoard/useCommonQuery";
import { useBoardListQuery } from "../../hooks/useBoard/useBoardQuery";

import ContentLayout from "../../layouts/ContentLayout";
import { ControlWriteArticle4Admin, ControlDataGrid, Columns4Board, ControlSnackbar, ControlCircularProgressBar, Dialog4Confirm, Dialog4Alert } from "../../components/board";


export default function Manage4Article () {
    const navigate = useNavigate();
    const auth = useRecoilValue(userInfo);
    const { t } = useTranslation();
    const isLoadingRef = React.useRef(false);
    const refConfirm = React.useRef(null);
    const refAlert = React.useRef(null);
    const refSnackbar = React.useRef(null);
    const showTimerControler = React.useRef(null);

    const [ pageTitle, setPageTitle ] = React.useState(t('nav.manage4article'));
    const { data: boardTypes } = useBoardType(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10,
    });
    const defaultQueryOptions = {
        BoardType: "",
        ManageId: 0,
        Page: paginationModel.page + 1,
        PageSize: paginationModel.pageSize,
        Title: "",
        Content: "",
    };
    const [queryOptions, setQueryOptions] = React.useState(defaultQueryOptions);
    const { isError, isLoading, isFetching, isSuccess, error, data: gridData, refetch } = useBoardListQuery(queryOptions);
    const [ dataSet, setDataSet ] = React.useState({
        records: [],
        rowLength: 0,
        editable: false,
        isLoading: false,
    });
    const [openEditDialog, setOpenEditDialog] = React.useState({
        isShow: false,
        manageId: null,
        boardId: null
    }); // 등록 창
    

    const closeEditDialog = (boolValue) => {
        if(boolValue) {
            // 조회를 다시한다.
        }
        if(openEditDialog.isShow) setOpenEditDialog({isShow: false, manageId: null, boardId: null});
    };

    const runSearch = (e) => {
        e.preventDefault();
        
        if (isLoadingRef.current)  return;
        isLoadingRef.current = true;
        showTimerControler.current.showTimer(2);

        let message = JSON.stringify(queryOptions);
        refSnackbar.current.openMessage(message + ':: 메시지 테스트');
        refetch();
        
        isLoadingRef.current = false;
    };

    const callDelete = () => {
        if(auth.userId === undefined || auth.userId === null || auth.userId === '') {
            refSnackbar.current.openMessage(`${t('error.notlogin')}`);
            setTimeout(() => {
                navigate(`/login`);
            }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
        }
        else {
            refConfirm.current.showMessageBox(`${t('button.delete')}`, `${t('alert.delete')}`, (result) => {
                if(result) {
                    /*
                        삭제 처리
                    */
                    refAlert.current.showMessageBox(`${t('button.delete')}`, `${t('message.deletecomplet')}`);
                }
            });
        }
    }

    const callRegistration = (e) => {
        e.preventDefault();

        if((auth.userId === undefined || auth.userId === null || auth.userId === '') || auth?.userType !== process.env.REACT_APP_BOARD_MANAGER_TYPE) {
            refSnackbar.current.openMessage(`${t('error.notlogin')}`);
            setTimeout(() => {
                navigate(`/login`);
            }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
        }
        else {
            if (isLoadingRef.current)  return;
            isLoadingRef.current = true;
            setOpenEditDialog({isShow: true, manageId: null, boardId: null});
            isLoadingRef.current = false;
        }
    };

    const onDataViewClick = (params) => {
        if((auth.userId === undefined || auth.userId === null || auth.userId === '') || auth?.userType !== process.env.REACT_APP_BOARD_MANAGER_TYPE) {
            refSnackbar.current.openMessage(`${t('error.notlogin')}`);
            setTimeout(() => {
                navigate(`/login`);
            }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
        }
        else {
            if (isLoadingRef.current)  return;
            isLoadingRef.current = true;

            setOpenEditDialog({
                isShow: true,
                manageId : params.row.ManageId,
                boardId : params.row.BoardId,
            });

            isLoadingRef.current = false;
        }
    };

    
    React.useEffect(() => {
        try {
            if(gridData !== undefined && gridData !== null)
            {
                setDataSet({...dataSet, records: gridData.data.Results, rowLength: gridData.data.TotalCnt, isLoading: false});
            }
        }
        catch(err)
        {
            console.log('No Data', new Date().toISOString(), queryOptions, err);
        }

        return () => {
        } 
    }, [isError, isLoading, isFetching, isSuccess, error, gridData]);

    React.useEffect(() => { 
        if (isDebug()) console.log("## UseEffect [paginationModel] paginationModel: ", new Date().toISOString(), JSON.stringify(paginationModel));
        setQueryOptions({...queryOptions, Page: paginationModel.page + 1, PageSize: paginationModel.pageSize});
        if (isDebug()) console.log("## UseEffect [paginationModel] queryOptions: ", new Date().toISOString(), JSON.stringify(queryOptions));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel]);


    return (
        <ContentLayout pageTitle={pageTitle} pageDescription={null} >

           <div className="page-description">
                <h1>FAQ, 자유게시판의 글 목록</h1>
                <p>※ 게시판 내용에 맞지는 않는 글은 삭제 가능합니다.</p>
                <p>※ QnA의 형식이외의 게시글을 조회합니다.</p>
            </div>

            {/* 검색 영역 */}
            <Container className="page-content" sx={{ p: 3 }}>
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ paddingRight: '10px'}} >
                        <FormControl sx={{ m: 0, p: 0, minWidth: 200, width: "100%" }} size="small">
                        <InputLabel id="board-type-select-small-label">{t('others.board')}</InputLabel>
                            <Select
                                labelId="board-type-select-small-label"
                                label={t('others.board')}
                                id="board-type-select-small"
                                placeholder={t('others.selectone')}
                                value={queryOptions.ManageId || ''}
                                onChange={(e) => setQueryOptions({...queryOptions, ManageId:e.target.value}) }
                                size="small"
                            >
                            <MenuItem value="">
                                <em>{t('searchfield.searchall')}</em>
                            </MenuItem>
                            {boardTypes ? boardTypes.map(item => {
                                return <MenuItem key={item.ManageId} value={item.ManageId}>{item.BoardName}</MenuItem>
                            })
                            : null
                            }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ paddingRight: '10px'}} >
                        <TextField
                            fullWidth
                            label={t('searchfield.subject')}
                            id="filled-hidden-label-small"
                            defaultValue={queryOptions.Title}
                            onChange={(v) => setQueryOptions({...queryOptions, Title:v.target.value}) }
                            size="small"
                            placeholder={t('searchfield.subject_placeholder')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ paddingRight: '10px'}} >
                        <TextField
                            fullWidth
                            label={t('searchfield.content')}
                            id="filled-hidden-label-small"
                            defaultValue={queryOptions.Content}
                            onChange={(v) => setQueryOptions({...queryOptions, Content:v.target.value}) }
                            size="small"
                            placeholder={t('searchfield.content_placeholder')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ textAlign: 'right' }} >
                        <div>
                            <Button variant="outlined" size="medium" startIcon={<SearchIcon />} onClick={runSearch}>
                                {t('button.search')}
                            </Button>
                            {' '}
                            <Button variant="outlined" size="medium" startIcon={<AddCircleIcon />} onClick={callRegistration} disabled={!auth.userId}>
                                {t('button.registration')}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Container>

            {/* 데이타 영역 */}
            <Container sx={{ width: '100%', height: '100%', alignItems: 'center', p: 1 }}>
                <ControlDataGrid t={t}
                    dataType="board"
                    manageId={queryOptions.ManageId}
                    boardColumns={Columns4Board}
                    dataSet={dataSet}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    isUseManager={true}
                    onCellClick={onDataViewClick}
                />
            </Container>

            {/* 알림 메시지 영역 */}
            <Dialog4Alert ref={refAlert} />
            <Dialog4Confirm ref={refConfirm} />
            <ControlSnackbar ref={refSnackbar} />
            <ControlCircularProgressBar ref={showTimerControler} initialTime={1} />
            <Typography>&nbsp;</Typography>

            {/* 게시글 등록 영역 */}
            <ControlWriteArticle4Admin id="writeArticle" open={openEditDialog.isShow} closeEditDialog={closeEditDialog} isQna={false} manageId={openEditDialog.manageId} boardId={openEditDialog.boardId} refMessage={showTimerControler.current} />

        </ContentLayout>
    );
}